import { useFragment } from '@apollo/client/react';
import { useParams } from 'react-router-dom';
import { PROJECT_SHELL_FRAGMENT } from '../../graphql/project';
import { ProjectShellFragment } from '../../types/graphqlTypes';

/**
 * Subscribes to non-annotation project fields via Apollo's useFragment.
 * Only re-renders when metadata changes (pointClouds, settings, layers, etc.),
 * NOT when annotations/groups/orderedIdentifiers change.
 *
 * Requires the PROJECT query to have been fetched first (populates the cache).
 */
export const useProjectShell = () => {
  const { projectId = '' } = useParams();
  const { data, complete } = useFragment<ProjectShellFragment>({
    fragment: PROJECT_SHELL_FRAGMENT,
    fragmentName: 'ProjectShell',
    from: { __typename: 'Project', id: projectId },
  });
  return complete ? data : undefined;
};
